import { Inject, Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { UserAuthService } from './user-auth.service';
import { PaginationResult } from '../_models/pagination-result.model';
import { getApiBaseUrl } from './runtime-config';

@Injectable({
  providedIn: 'root',
})
export class DeviceLocationService {
  private http = inject(HttpClient);
  private auth = inject(AuthenticationService);
  private apiBaseUrl = getApiBaseUrl();

  getDeviceLocationPaginate(
    start: string,
    end: string,
    deviceID: string,
    currentPage: number,
    pageSize: number = 10
  ): Observable<PaginationResult> {
    const locationUrl = `${this.apiBaseUrl}/admin/device/${deviceID}/location`;
    const params = new HttpParams()
      .set('page', currentPage.toString())
      .set('pageSize', pageSize.toString());
    return this.http.post<PaginationResult>(
      locationUrl,
      { start: start, end: end },
      { params: params }
    );
  }

  getUserLocationPaginate(
    start: string,
    end: string,
    userID: string,
    currentPage: number,
    pageSize: number = 10
  ): Observable<PaginationResult> {
    const locationUrl = `${this.apiBaseUrl}/admin/itt-user/${userID}/locations`;
    const params = new HttpParams()
      .set('page', currentPage.toString())
      .set('pageSize', pageSize.toString());
    return this.http.post<PaginationResult>(
      locationUrl,
      { start: start, end: end },
      { params: params }
    );
  }

  downloadDeviceLocationKmlFile(
    startDate: Date,
    endDate: Date,
    deviceID: string
  ) {
    const tokenObj = JSON.parse(this.auth.retrieveToken());
    const start = startDate.getTime();
    const end = endDate.getTime();
    const token = encodeURIComponent(tokenObj.token);
    const locationUrl = `${this.apiBaseUrl}/admin/device/${deviceID}/location/download/${start}/${end}?token=${token}`;
    window.location.href = locationUrl;
  }

  downloadUserLocationKmlFile(startDate: Date, endDate: Date, userID: string) {
    const tokenObj = JSON.parse(this.auth.retrieveToken());
    const start = startDate.getTime();
    const end = endDate.getTime();
    const token = encodeURIComponent(tokenObj.token);
    // align with legacy API route used by the old site
    const locationUrl = `${this.apiBaseUrl}/admin/user/${userID}/location/download/${start}/${end}?token=${token}`;
    window.location.href = locationUrl;
  }
}
